import { create } from 'zustand'
import { persist } from 'zustand/middleware'

// Email type matching the Contact app
export interface Email {
  id: string
  folder: string
  from: string
  fromName: string
  to: string
  subject: string
  body: string
  date: string
  read: boolean
  starred: boolean
  threadId?: string
  inReplyTo?: string
  references?: string[]
}

// A local reply stores both the user's message and the AI response
export interface LocalReply {
  id: string
  originalEmailId: string
  userReplyText: string
  userReplyDate: string
  aiResponse: Email
}

interface MailState {
  localReplies: LocalReply[]

  // Actions
  addReply: (originalEmailId: string, userReplyText: string, aiResponse: Email) => void
  getRepliesForEmail: (emailId: string) => LocalReply[]
  clearReplies: () => void
}

export const useMailStore = create<MailState>()(
  persist(
    (set, get) => ({
      localReplies: [],

      addReply: (originalEmailId, userReplyText, aiResponse) => {
        const newReply: LocalReply = {
          id: `reply-${Date.now()}`,
          originalEmailId,
          userReplyText,
          userReplyDate: new Date().toISOString(),
          aiResponse,
        }

        set((state) => ({
          localReplies: [...state.localReplies, newReply],
        }))
      },

      getRepliesForEmail: (emailId) => {
        return get().localReplies.filter(
          (r) => r.originalEmailId === emailId || r.aiResponse.id === emailId
        )
      },

      clearReplies: () => set({ localReplies: [] }),
    }),
    {
      name: 'persona-os-mail',
      version: 1,
    }
  )
)
